import { Location } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HumiInquiryStatus } from '@app/models/kyc-kyb/types';
import { TranslateModule } from '@ngx-translate/core';
import { KYCKYBBadge } from '../kyc-kyb-badge/kyc-kyb-badge.component';
import { type PersonaScope } from '../types';

@Component({
    templateUrl: 'kyc-kyb-header.template.html',
    selector: 'app-kyc-kyb-header',
    standalone: true,
    imports: [MatIconModule, TranslateModule, KYCKYBBadge],
    styleUrls: ['./kyc-kyb-header.style.scss'],
})
export class KYCKYBHeader {
    scope = input.required<PersonaScope>();
    status = input.required<HumiInquiryStatus | undefined>();
    hasBackButton = input<boolean>(false);
    headingLevel = input<'1' | '2' | '3'>('2');

    constructor(public location: Location) {}
}
